import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, ErrorHandler, Injector } from "@angular/core";
import { TranslatedToastrService } from "../services/translated-toastr.service";
import { ApiProblemDetailsModel, BaseResponse } from "../services/api-services";
import { TranslateService } from '@ngx-translate/core';
import { FormatService } from "../services/format.service";

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector, private formatService: FormatService) { }

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            console.error('Error from global error handler', error);
        }
        else {
            let toastr = this.injector.get(TranslatedToastrService);

            let translateService = this.injector.get(TranslateService);
            let errorTitle = translateService.instant('common.error');

            let apiProblem = error as ApiProblemDetailsModel;
            let bResponse = error as BaseResponse;
            if (apiProblem && typeof apiProblem === 'object' && 'title' in apiProblem) {
                console.log(apiProblem);
                toastr.error(apiProblem.detail!, apiProblem.title, {
                    onActivateTick: true
                });
            }
            else if (bResponse && typeof bResponse === 'object' && 'isSuccess' in bResponse) {
                toastr.error(bResponse.message!, errorTitle, {
                    onActivateTick: true
                }, bResponse.additionalInformation!);
            }
            else {
                if (error.message) {
                    if (error.status != 504 &&
                        error.status != 0 &&
                        (error.status == undefined && error.name && error.name != "EmptyError" && error.message != "no elements in sequence" && error.message != "Cannot read properties of null (reading 'parentNode')")) {
                        const errorMessage = `${error.message} - ${this.formatService.formatDateTime(new Date())}`;
                        console.log(error);
                        alert("GlobalErrorHandler - withmessage - " + errorMessage);
                    }
                } else {
                    const errorMessage = `${JSON.stringify(error)} - ${this.formatService.formatDateTime(new Date())}`;
                    console.log(error);
                    alert("GlobalErrorHandler - withoutmessage " + errorMessage);
                }
                if (error.status == 504 || error.status == 0) {
                    let checkInternetConnectionMessage = translateService.instant('common.check_internet_connection');
                    console.log(error);
                    toastr.error(checkInternetConnectionMessage, errorTitle, {
                        onActivateTick: true
                    });
                    //EmptyError with no elements in sequence arrives when the firstValueFrom got an error because there is no response, probably because of the user is not authorized for that request
                } else if (error.status == 401 || (error.name && error.name == "EmptyError" && error.message == "no elements in sequence")) {
                    let authErrorMessage = translateService.instant('common.auth_error');
                    console.log(error);
                    toastr.error(authErrorMessage, errorTitle, {
                        onActivateTick: true
                    });
                } else {
                    if (error.message == "Cannot read properties of null (reading 'parentNode')") {
                        return;
                    }
                    console.log(error);
                    toastr.error(error.message, errorTitle, {
                        onActivateTick: true
                    });
                }
            }
        }
    }
}
